module.exports = __webpack_public_path__ + "static/594-acb2b1a5540d97f137dab6ca157c2ad7.png";